export default {    
    Java: `class sumOfMultiples {
            static public void main( String args[] ) {
                int sum = 0;
                for (int i = 0; i < 1000; i++) {
                    if (i % 3 == 0 || i % 5 == 0)
                        sum += i;
                }
            System.out.println( sum );
        }
}`,
    JavaScript: `let sum = 0
        for (let i=1; i<1000; i++){
            if((i%3 == 0) || (i%5 == 0)){
                sum += i;
            }
        }
console.log(sum)
    `,
    Python: `sum = 0
    for i in range(1, 1000):
    if i%3 == 0 or i%5 == 0:
        s += i
    print (s)
    `
}